import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing prices for corn, wheat, soybean and the index',
    'Index based on 2003-06 average prices for corn, wheat, soybean',
    'Prices received for All Wheat, Corn, and Soybeans by month - United States',
    'Source: USDA Agricultural Prices, producer price level (monthly prices)',
  ];
  return description;
}